import { useSyncExternalStore } from "react";
import { localeChangeEvent, readLocale, type Locale } from "./i18n";

function subscribe(listener: () => void) {
  window.addEventListener(localeChangeEvent, listener);
  const onStorage = (event: StorageEvent) => {
    if (event.key === "edubgt_locale" || event.key === null) listener();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(localeChangeEvent, listener);
    window.removeEventListener("storage", onStorage);
  };
}

export function usePlatformLocale(): Locale {
  return useSyncExternalStore(subscribe, readLocale, () => "sq");
}
